module.exports = __webpack_public_path__ + "img/cert_xl.fbb5e33.webp";